<div class="dialog-agent">
  <div mat-dialog-content class="">
    <div>
      <div class="w-100 d-inline-block text-center pt-2 pb-4">
        <i class="fas fa-spinner fa-pulse fa-2x mb-2 text-info"></i> <br>
        <b class="text-info h4 px-2">{{connectionLost}}</b>
      </div>
    </div>
  </div>
</div>
